<template>
  <span
    class="die"
    :class="{ 'die--dim': dim, 'die--placeholder': placeholder }"
    role="img"
    :aria-label="placeholder ? 'no dice rolled yet' : `die showing ${value}`"
  >
    <i v-for="n in 9" :key="n" class="die__pip" :class="{ 'die__pip--on': !placeholder && pips.includes(n) }" />
  </span>
</template>

<script>
// One die, drawn as a 3x3 pip grid. Cells number 1-9 left-to-right,
// top-to-bottom; each face lights the standard pip cells.
const PIP_CELLS = {
  1: [5],
  2: [3, 7],
  3: [3, 5, 7],
  4: [1, 3, 7, 9],
  5: [1, 3, 5, 7, 9],
  6: [1, 3, 4, 6, 7, 9],
};

export default {
  name: 'DieFace',
  props: {
    value: { type: Number, default: 0 },
    // Dimmed while the dice on show are last roll's, not a live choice.
    dim: { type: Boolean, default: false },
    // An empty die, drawn so the tray holds its height before the first roll
    // of a turn. See GameTable's .tray - the whole point is that nothing in
    // the action area moves as the turn goes on.
    placeholder: { type: Boolean, default: false },
  },
  computed: {
    pips() { return PIP_CELLS[this.value] || []; },
  },
};
</script>
